module.exports = __webpack_public_path__ + "static/img/cart4.fb4bc6c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cart4.png
// module id = jz1N
// module chunks = 2